import { Component, ReactNode } from 'react'
import './ErrorBoundary.css'

interface Props {
  children: ReactNode
}

interface State {
  hasError: boolean
  error: Error | null
}

export default class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }


  render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary">
          <div className="error-boundary-content">
            <h2>⚠️ Что-то пошло не так</h2>
            <p>Произошла ошибка при загрузке страницы.</p>
            {this.state.error && (
              <details className="error-details">
                <summary>Детали ошибки</summary>
                <pre>{this.state.error.toString()}</pre>
              </details>
            )}
            <button
              className="btn btn-primary"
              onClick={() => {
                this.setState({ hasError: false, error: null })
                const url = new URL(window.location.href)
                url.searchParams.set('_app_reload', Date.now().toString())
                window.location.replace(url.toString())
              }}
            >
              Перезагрузить страницу
            </button>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}

